import { render, staticRenderFns } from "./PopupMenu.vue?vue&type=template&id=48e5d29c&scoped=true"
import script from "./PopupMenu.vue?vue&type=script&lang=ts"
export * from "./PopupMenu.vue?vue&type=script&lang=ts"
import style0 from "./PopupMenu.vue?vue&type=style&index=0&id=48e5d29c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e5d29c",
  null
  
)

export default component.exports